var React = require('react');

function LinkedinIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m19 3c1.1 0 2 .89 2 2v14c0 1.1-.9 2-2 2h-14c-1.11 0-2-.9-2-2v-14c0-1.11.89-2 2-2zm-.5 15.5v-5.3-.001c-.001-1.81-1.46-3.26000144-3.26-3.26000144-.85-.00099856-1.84.52000144-2.32 1.30000144v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4h-.001c.77 0 1.4.62 1.4 1.4v4.93h2.79m-11.62-9.949c.92 0 1.68-.76 1.68-1.68 0-.93-.75-1.69-1.68-1.69-.94 0-1.69.75-1.69 1.69 0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37h-2.779v8.37h2.77z"}));
}

LinkedinIconInline.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = LinkedinIconInline;

LinkedinIconInline.default = LinkedinIconInline;
